<template>
  <HeadlessLayout :sections="content" />
</template>

<script>
import SustainabilityPlanetContent from "@/content/SustainabilityPlanet.json";
import HeadlessLayout from "@/layouts/HeadlessLayout.vue";

export default {
  name: "Planet",
  components: {
    HeadlessLayout,
  },
  data() {
    return {
      content: SustainabilityPlanetContent,
    };
  },
};
</script>
